export default __webpack_public_path__ + "static/media/image-3.11db17f0.png";